import { Card, Button } from '@achieve/ascend'
import { Typography } from 'components/Typography'
import { Image } from 'components/Image'
import { X } from 'react-feather'
import { useEffect } from 'react'
import { useViewportSmallerThan } from 'utils/viewport'
import { useTriggerEvents } from 'hooks/useTriggerEvents'
import useBodyScrollLock from 'hooks/useBodyScrollLock'
import { BREAKPOINTS } from 'constants/viewport'
import styles from './QuizFlowSplash.module.scss'
import { GradientBadge } from './GradientBadge'
import { TrackingWrapper } from 'components/Tracking/TrackingWrapper'

const QuizFlowSplash = function ({ onStart, onClose }) {
  const { fireAndForget } = useTriggerEvents()

  // Lock body scroll while the splash is mounted
  useBodyScrollLock(true)

  useEffect(() => {
    // Splash Loaded/Displaying event
    fireAndForget({
      event_type: 'app_event',
      event_action: 'app_event',
      nav_link_section: 'PFQ Splash',
      track_event: 'product_fit_quiz_splash_loaded',
    })
  }, [fireAndForget])

  const isMobile = useViewportSmallerThan(BREAKPOINTS.lg)

  return (
    <div className={styles['splash-container']}>
      <Card className={styles['splash-card']} variant="elevation">
        <div className={styles['pattern-background']}>
          <Image
            src="/multi-site-assets/achieve-arrow-pattern.svg"
            alt="Background pattern"
            layout="fill"
            preload={false}
          />
        </div>
        <div className={styles['clickable-container']}>
          <TrackingWrapper
            track={{
              event_type: 'ui_click',
              event_action: 'ui_click',
              nav_link_section: 'PFQ Splash',
              track_event: 'product_fit_quiz_splash_close',
            }}
            onClick={onClose}
          >
            <div
              height={24}
              width={24}
              style={{
                cursor: 'pointer',
                minWidth: '24px',
                minHeight: '24px',
                marginLeft: 'auto',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <X
                size={20}
                preload={false}
                aria-hidden={true}
                alt="Close button"
                data-testid="pfq-x-icon"
              />
            </div>
          </TrackingWrapper>
        </div>
        <div className={styles['content-container']}>
          <GradientBadge
            width={isMobile ? 55 : 64}
            height={isMobile ? 33 : 38}
            background={'#2950f8'}
          >
            <Typography variant={isMobile ? 'labelButtonSm' : 'labelButtonMd'}>Quiz</Typography>
          </GradientBadge>

          <Typography variant="displayMd" style={{ marginTop: '18px' }}>
            Let&apos;s make sense of your financial situation
          </Typography>
          <Typography variant="bodyMd" style={{ marginTop: '18px' }}>
            We&apos;ll ask four quick questions to understand where you are financially — and see
            how we can help you.
            <br />
            <br />
            It&apos;ll take less than a minute.
          </Typography>
          <TrackingWrapper
            track={{
              event_type: 'button_click',
              event_action: 'button_click',
              nav_link_section: 'PFQ Splash',
              track_event: 'product_fit_quiz_splash_cta',
            }}
            onClick={onStart}
          >
            <Button variant="contained" color="secondary" className={styles['button']}>
              <Typography color={'#3300FF'} variant="labelButtonMd">
                Start the quiz
              </Typography>
            </Button>
          </TrackingWrapper>
        </div>
      </Card>
    </div>
  )
}

export { QuizFlowSplash }
